import { render, staticRenderFns } from "./ClinicReserveTabs.vue?vue&type=template&id=18e0d245&scoped=true"
import script from "./ClinicReserveTabs.vue?vue&type=script&lang=js"
export * from "./ClinicReserveTabs.vue?vue&type=script&lang=js"
import style0 from "./ClinicReserveTabs.vue?vue&type=style&index=0&id=18e0d245&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e0d245",
  null
  
)

export default component.exports